import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, Star, ArrowLeft, Zap, Crown, Rocket, Award } from 'lucide-react';

const plans = [
  {
    id: 'amador',
    name: 'Parceiro Inicial',
    subtitle: 'Comece a vender',
    price: '49,90',
    icon: Zap,
    color: '#3b82f6',
    features: [
      'Ate 15 produtos',
      '3 opcoes de cores',
      '1 template visual',
      'Upload de logo',
      'Site proprio (/parceiros/slug)',
      'Landing pages de produtos',
      'Contato via WhatsApp',
    ],
    notIncluded: ['Upload de banner', 'Analytics', 'Suporte prioritario', 'Destaque na plataforma'],
  },
  {
    id: 'profissional',
    name: 'Parceiro Profissional',
    subtitle: 'Cresça seu negócio',
    price: '89,90',
    icon: Rocket,
    color: '#8b5cf6',
    popular: true,
    features: [
      'Ate 30 produtos',
      '5 opcoes de cores',
      '3 templates visuais',
      'Upload de logo e banner',
      'Site proprio (/parceiros/slug)',
      'Landing pages de produtos',
      'Contato via WhatsApp',
      'Destaque na plataforma',
    ],
    notIncluded: ['Analytics', 'Suporte prioritario'],
  },
  {
    id: 'expert',
    name: 'Parceiro Avançado',
    subtitle: 'Estrutura completa',
    price: '129,90',
    icon: Award,
    color: '#f59e0b',
    features: [
      'Ate 45 produtos',
      '8 opcoes de cores',
      '5 templates visuais',
      'Upload de logo e banner',
      'Site proprio (/parceiros/slug)',
      'Landing pages de produtos',
      'Analytics de visitas',
      'Destaque na plataforma',
    ],
    notIncluded: ['Suporte prioritario'],
  },
  {
    id: 'ocara',
    name: 'Parceiro Enterprise',
    subtitle: 'Operação em grande escala',
    price: '249,90',
    icon: Crown,
    color: '#22c55e',
    features: [
      'Produtos ilimitados',
      'Cores ilimitadas',
      'Templates ilimitados',
      'Upload de logo e banner',
      'Site proprio (/parceiros/slug)',
      'Landing pages de produtos',
      'Analytics completo',
      'Destaque premium na plataforma',
      'Suporte especializado dedicado',
      'Acompanhamento personalizado',
    ],
    notIncluded: [],
  },
];

const PartnersPlansPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)' }}>
      <div className="max-w-[1300px] mx-auto px-6 py-12">
        <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-white/60 hover:text-white mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Voltar
        </button>

        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4" data-testid="plans-title">Planos para Parceiros</h1>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Escolha o plano ideal para o seu negocio e comece a vender na Agro Urban Global
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {plans.map((plan) => {
            const Icon = plan.icon;
            return (
              <div key={plan.id}
                className={`relative rounded-2xl p-6 border transition-all hover:scale-[1.02] ${
                  plan.popular ? 'border-purple-500 bg-white/10' : 'border-white/10 bg-white/5'
                }`}
                data-testid={`plan-${plan.id}`}
              >
                {plan.popular && (
                  <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-purple-500 text-white text-xs font-bold px-4 py-1 rounded-full">
                    MAIS POPULAR
                  </div>
                )}

                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4" style={{ background: `${plan.color}20` }}>
                  <Icon className="w-6 h-6" style={{ color: plan.color }} />
                </div>

                <h3 className="text-lg font-bold text-white">{plan.name}</h3>
                <p className="text-white/40 text-sm">{plan.subtitle}</p>

                <div className="mt-4 mb-6">
                  <span className="text-4xl font-bold text-white">R$ {plan.price}</span>
                  <span className="text-white/40">/mes</span>
                </div>

                <ul className="space-y-2.5 mb-6">
                  {plan.features.map((f, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm">
                      <Check className="w-4 h-4 text-green-400 flex-shrink-0 mt-0.5" />
                      <span className="text-white/80">{f}</span>
                    </li>
                  ))}
                  {plan.notIncluded.map((f, i) => (
                    <li key={`not-${i}`} className="flex items-start gap-2 text-sm opacity-30">
                      <span className="w-4 h-4 flex-shrink-0 mt-0.5 text-center">-</span>
                      <span className="text-white/60 line-through">{f}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => navigate('/parceiro/cadastro', { state: { plan: plan.id } })}
                  className="w-full py-3 rounded-xl font-bold text-white transition-all"
                  style={{ background: `linear-gradient(135deg, ${plan.color}, ${plan.color}cc)` }}
                  data-testid={`select-plan-${plan.id}`}
                >
                  Comecar Agora
                </button>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <p className="text-white/40 text-sm">
            Todos os planos incluem site proprio, landing pages de produtos e contato via WhatsApp.
            <br />Duvidas? Entre em contato conosco.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PartnersPlansPage;
